export default __webpack_public_path__ + "static/media/banner-mobile.8b6bd5d4.png";